import './App.css';
import StockitySectorFinder from './components/StockitySectorFinder';

function App() {
  return (
    <div className="App">
      <StockitySectorFinder />
    </div>
  );
}

export default App;